import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';
import type { IMaterialResponse } from '@alfa-bank/site-invest-mediaportal-common/src/models';

import type { IAnalytics } from '../models';

export const sendClickCardAnalytics = (card: IMaterialResponse, analytics: IAnalytics) => {
    sendEvent({
        ...analytics?.clickCardArticles,
        label_detail: `${card.category.description} - ${card.title}`,
    });
};
